
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404RTty66vHR3j78BKCZbFzC5EAyHYKVU1rof9XF6jlJloMeta } from "/vercel/path0/apps/frontend/src/pages/404.vue?macro=true";
import { default as index3x1XK3PeN0sbE8N2ZRdXcNiWdHxl57k_mLEAFbu92EQMeta } from "/vercel/path0/apps/frontend/src/pages/index.vue?macro=true";
import { default as linksThDWovJfY9ybJgMipm9DWTqA356BNY5Ke_45lTq6yZKFgMeta } from "/vercel/path0/apps/frontend/src/pages/links.vue?macro=true";
import { default as client_45mode_45irnjXMtBOQ5U3C4vgRIoJRRttpaVVQFq3EawRBltEEBWoMeta } from "/vercel/path0/apps/frontend/src/pages/client-mode-ir.vue?macro=true";
import { default as client_45mode_45we60ArHFXVlM5SKVLbfmxsXptzO4Kj2fBCqvUCm9DVeHYMeta } from "/vercel/path0/apps/frontend/src/pages/client-mode-we.vue?macro=true";
import { default as iframe_45examplei75CCUGktWcMwjAEYUi7Fyfn2spGEGQzdJkJGPPMgQEMeta } from "/vercel/path0/apps/frontend/src/pages/iframe-example.vue?macro=true";
import { default as white_45elephantMYdgFSgWMi_ERhP9jf2pGnJqdO8uNZivsldRnChIkpoMeta } from "/vercel/path0/apps/frontend/src/pages/white-elephant.vue?macro=true";
import { default as async_45experienceBwV7ZJuKmSncVQPHcrVrVHvmLt0U4y2c_H43YxM9vIMMeta } from "/vercel/path0/apps/frontend/src/pages/async-experience.vue?macro=true";
import { default as client_45mode_45async5W_QYcCDZE3qVvVETkcehrDsI2u1bhGwV1B4w5WDU8kMeta } from "/vercel/path0/apps/frontend/src/pages/client-mode-async.vue?macro=true";
import { default as _91_46_46_46slug_93_gppclknuEhKYUsom_eTpUlzeMgj63qHNjXG1EmSUo4Meta } from "/vercel/path0/apps/frontend/src/pages/sandbox/[...slug].vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    meta: _404RTty66vHR3j78BKCZbFzC5EAyHYKVU1rof9XF6jlJloMeta || {},
    component: () => import("/vercel/path0/apps/frontend/src/pages/404.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/apps/frontend/src/pages/index.vue")
  },
  {
    name: "links",
    path: "/links",
    meta: linksThDWovJfY9ybJgMipm9DWTqA356BNY5Ke_45lTq6yZKFgMeta || {},
    component: () => import("/vercel/path0/apps/frontend/src/pages/links.vue")
  },
  {
    name: "client-mode-ir",
    path: "/client-mode-ir",
    meta: client_45mode_45irnjXMtBOQ5U3C4vgRIoJRRttpaVVQFq3EawRBltEEBWoMeta || {},
    component: () => import("/vercel/path0/apps/frontend/src/pages/client-mode-ir.vue")
  },
  {
    name: "client-mode-we",
    path: "/client-mode-we",
    meta: client_45mode_45we60ArHFXVlM5SKVLbfmxsXptzO4Kj2fBCqvUCm9DVeHYMeta || {},
    component: () => import("/vercel/path0/apps/frontend/src/pages/client-mode-we.vue")
  },
  {
    name: "iframe-example",
    path: "/iframe-example",
    component: () => import("/vercel/path0/apps/frontend/src/pages/iframe-example.vue")
  },
  {
    name: "white-elephant",
    path: "/white-elephant",
    component: () => import("/vercel/path0/apps/frontend/src/pages/white-elephant.vue")
  },
  {
    name: "async-experience",
    path: "/async-experience",
    component: () => import("/vercel/path0/apps/frontend/src/pages/async-experience.vue")
  },
  {
    name: "client-mode-async",
    path: "/client-mode-async",
    meta: client_45mode_45async5W_QYcCDZE3qVvVETkcehrDsI2u1bhGwV1B4w5WDU8kMeta || {},
    component: () => import("/vercel/path0/apps/frontend/src/pages/client-mode-async.vue")
  },
  {
    name: "sandbox-slug",
    path: "/sandbox/:slug(.*)*",
    meta: _91_46_46_46slug_93_gppclknuEhKYUsom_eTpUlzeMgj63qHNjXG1EmSUo4Meta || {},
    component: () => import("/vercel/path0/apps/frontend/src/pages/sandbox/[...slug].vue")
  }
]